import createLogger from '@/lib/logger'
import { useAppStore } from '@/store/app'

import { authGuard } from './guards/authGuard'
import { lastVisitedRouteGuard } from './guards/lastVisitedRouteGuard'
import { noAccessGuard } from './guards/noAccessGuard'
import { routeSanitisationGuard } from './guards/routeSanitisationGuard'
import { undefinedRouteGuard } from './guards/undefinedRouteGuard'
import { userRoleGuard } from './guards/userRoleGuard'

import type { RouteLocationNormalized } from 'vue-router'

/**
 * Ordered aray of route guards.
 * Note: the order is important since the guards get executed in sequence
 */
const guards = [
  routeSanitisationGuard,
  undefinedRouteGuard,
  noAccessGuard,
  authGuard,
  userRoleGuard,
  lastVisitedRouteGuard,
]

const logger = createLogger('beforeEach')

export const beforeEach = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
) => {
  // During bootstrap, skip guards until Keycloak finishes, except the forced
  // same-URL `replace` in `setIsAppLoaded` (see `shouldRunRouterGuards`).
  if (!useAppStore().shouldRunRouterGuards) {
    return true
  }

  logger.log('\n\n------------------------------------')
  logger.log('to:', to)
  logger.log('from:', from)
  logger.log('------------------')

  for (const routeGuard of guards) {
    const result = await routeGuard(to)
    // 'undefined' result means that the guards should continue running
    if (result !== undefined) {
      return result
    }
  }
}
